import { isString } from 'lib';
import { isArabicOrPersian } from './validation';

export const charAvatar = (name = '') => {
  if (!isString(name) || !name?.trim()) {
    return '??';
  }

  const names = name
    .trim()
    .split(' ')
    .filter((n) => n);

  if (isArabicOrPersian(name)) {
    return names[1] ? `${names[0][0]}\u200C${names[1][0]}` : names[0][0];
  }

  return names[1] ? names[0][0] + names[1][0] : names[0][0];
};
